import { Modal, ModalOverlay } from '@chakra-ui/react';
import { TModalProps } from '@@types/popup';

export default function PopupModal({
  isOpen,
  closePopup,
  children,
  popupOptions,
}: TModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={closePopup}
      closeOnEsc
      isCentered
      {...popupOptions}
    >
      <ModalOverlay>{children}</ModalOverlay>
    </Modal>
  );
}
